import {
  CHANGE_USER_PASSWORD,
  CONNECT_COMPANY_DRIVE,
  CONNECT_COMPANY_DRIVE_RESULT,
  CREATE_USER_CLIENT_SUCCESS,
  DELETE_DEPARTMENT,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_FREELANCER,
  DELETE_FREELANCER_SUCCESS,
  DELETE_POSITION,
  DELETE_POSITION_SUCCESS,
  DELETE_USER_ROLE,
  DELETE_USER_ROLE_SUCCESS,
  LOAD_CLIENT_PROFILES,
  LOAD_CLIENT_PROFILES_SUCCESS,
  LOAD_CLIENT_USER_BY_ID,
  LOAD_CLIENT_USER_BY_ID_SUCCESS,
  LOAD_CMS_LIST,
  LOAD_CMS_LIST_SUCCESS,
  LOAD_COMPANIES,
  LOAD_COMPANIES_SUCCESS,
  LOAD_COMPANY_BY_ID,
  LOAD_COMPANY_BY_ID_SUCCESS,
  LOAD_DEPARTMENTS,
  LOAD_DEPARTMENTS_SUCCESS,
  LOAD_FREELANCERS,
  LOAD_FREELANCERS_SUCCESS,
  LOAD_MODERATE_COUNT,
  LOAD_MODERATE_COUNT_SUCCESS,
  LOAD_POSITIONS,
  LOAD_POSITIONS_SUCCESS,
  LOAD_STRUCTURE_CHART,
  LOAD_STRUCTURE_CHART_SUCCESS,
  LOAD_USER_BY_ID,
  LOAD_USER_BY_ID_SUCCESS,
  LOAD_USER_LAST_TASK,
  LOAD_USER_LAST_TASK_SUCCESS,
  LOAD_USER_ROLES,
  LOAD_USER_ROLES_SUCCESS,
  LOAD_USERS,
  LOAD_USERS_SUCCESS,
  PASSWORD_FILLING,
  SET_USERS_ONLINE,
  SIGN_UP_CONFIRM,
  SUBSCRIBE_ONLINE,
  UNSUBSCRIBE_ONLINE,
  UPDATE_CLIENT_USER,
  UPDATE_CLIENT_USER_SUCCESS,
  UPDATE_DEPARTMENT,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_FREELANCER,
  UPDATE_FREELANCER_SUCCESS,
  UPDATE_POSITION,
  UPDATE_POSITION_SUCCESS,
  UPDATE_ROLE_ASSIGNMENT,
  UPDATE_ROLE_ASSIGNMENT_SUCCESS,
  UPDATE_USER,
  UPDATE_USER_COMPANY,
  UPDATE_USER_COMPANY_SUCCESS,
  UPDATE_USER_ROLE,
  UPDATE_USER_ROLE_SUCCESS,
  UPDATE_USER_SUCCESS,
  UPDATE_USERNAME,
  DISCONNECT_TELEGRAM,
  DISCONNECT_TELEGRAM_SUCCESS,
  CLEAR_CLIENT_PROFILES,
  CLEAR_DEPARTMENTS,
  CLEAR_USERS,
  CLEAR_POSITIONS,
  SUBSCRIBE_CREDENTIAL_MODERATE_COUNT,
  UNSUBSCRIBE_CREDENTIAL_MODERATE_COUNT,
  SUBSCRIBE_EVENT_MODERATE_COUNT,
  UNSUBSCRIBE_EVENT_MODERATE_COUNT,
  SET_CREDENTIAL_MODERATE_COUNT_SOCKET,
  SET_EVENT_MODERATE_COUNT_SOCKET,
  LOAD_WORKSPACES,
  LOAD_WORKSPACES_SUCCESS,
  SELECT_WORKSPACE,
  DETECT_CHANGE_WORKSPACE,
} from 'constants/ActionTypes';
import { FREELANCER_TABLE } from 'constants/SettingConstants';
import { getIntlMessage } from 'helpers/utilHelpers';
import {
  toggleClientInvitationForm,
  toggleDepartmentForm,
  toggleFreelancerForm,
  togglePositionForm,
  toggleRoleForm,
  toggleUserChangePasswordForm,
  toggleUserClientForm,
  toggleUserInviteForm,
} from 'actions/ui/formActions';

import { getFiltersByKey, getSearch } from 'selectors/settingsSelectors';
import { createTeamMap } from './projectActions';
import { userSignInSuccess } from '../authActions';

export const USERS = 'users';
export const WORKSPACES = 'workspaces';
export const USER_PROFILES = 'user-profiles';
export const CLIENT_PROFILES = 'client-profiles';

// Begin loading of the departments
export const loadDepartments = (payload = {}) => {
  const { page = null, perPage = 0 } = payload;
  return {
    type: LOAD_DEPARTMENTS,
    payload: {
      resource: 'user-departments',
      onSuccess: loadDepartmentsSuccess,
      onErrorMessage: getIntlMessage('department.load.error'),
      perPage,
      page,
    },
  };
};

// Update departments if loading is succeed
export const loadDepartmentsSuccess = (departments) => {
  return {
    type: LOAD_DEPARTMENTS_SUCCESS,
    departments,
  };
};

export const clearDepartments = () => {
  return {
    type: CLEAR_DEPARTMENTS,
  };
};

// Begin loading of the users
export const loadUsers = (payload = {}) => {
  return {
    type: LOAD_USERS,
    payload: {
      resource: USER_PROFILES,
      onSuccess: loadUsersSuccess,
      onErrorMessage: getIntlMessage('user.load.error'),
      ...payload,
    },
  };
};

// Begin loading of the users used before appReady
export const loadUsersInitial = (payload = {}) => {
  return {
    type: LOAD_USERS,
    payload: {
      resource: USER_PROFILES,
      onSuccess: loadUsersSuccess,
      onErrorMessage: getIntlMessage('user.load.error'),
      fields: [
        'userId',
        'departmentId',
        'positionId',
        'avatarColor',
        'companyId',
        'email',
        'firstname',
        'lastname',
        'patronym',
        'projectClientCount',
        'projectCount',
        'projectHours',
        'relatedPositionInTasks',
        'isLeader',
        'isManager',
        'isResponsible',
        'status',
        'timeActivity',
        'userType',
        'phone',
        'description',
        'image',
        'companyName',
        'enrollmentDate',
        'superiorId',
        'hourlyRate',
      ],
      ...payload,
    },
  };
};

export const clearUsers = () => {
  return {
    type: CLEAR_USERS,
  };
};

// Update users if loading is succeed
export const loadUsersSuccess = (users) => {
  return {
    type: LOAD_USERS_SUCCESS,
    users,
  };
};

// Begin loading of the positions
export const loadPositions = (payload = {}) => {
  const { page = null, perPage = 0 } = payload;
  return {
    type: LOAD_POSITIONS,
    payload: {
      resource: 'user-positions',
      onSuccess: loadPositionsSuccess,
      onErrorMessage: getIntlMessage('position.load.error'),
      perPage,
      page,
    },
  };
};

// Update positions if loading is succeed
export const loadPositionsSuccess = (positions) => {
  return {
    type: LOAD_POSITIONS_SUCCESS,
    positions,
  };
};

export const clearPositions = () => {
  return {
    type: CLEAR_POSITIONS,
  };
};

// Load user by specified userId
export const loadUserById = (userId) => {
  return {
    type: LOAD_USER_BY_ID,
    userId,
  };
};

// Save loaded user to the state
export const loadUserByIdSuccess = (user) => {
  return {
    type: LOAD_USER_BY_ID_SUCCESS,
    user,
  };
};

// Load all user roles of the current company
export const loadUserRoles = () => {
  return {
    type: LOAD_USER_ROLES,
    payload: {
      resource: 'user-roles',
      onSuccess: loadUserRolesSuccess,
      onErrorMessage: getIntlMessage('role.load.error'),
    },
  };
};

// Save loaded user roles
export const loadUserRolesSuccess = (roles) => {
  return {
    type: LOAD_USER_ROLES_SUCCESS,
    roles,
  };
};

// Loads all freelancers of the current company
export const loadFreelancers = (payload = {}) => {
  return {
    type: LOAD_FREELANCERS,
    payload: {
      resource: 'user-contractors',
      onSuccess: loadFreelancersSuccess,
      onErrorMessage: getIntlMessage('freelancer.load.error'),
      filters: {
        search: {
          selector: getSearch,
        },
        status: {
          selector: (state) => getFiltersByKey(state, { settingKey: FREELANCER_TABLE }),
          key: 'status',
          skipValue: 'all',
        },
        cms: {
          selector: (state) => getFiltersByKey(state, { settingKey: FREELANCER_TABLE }),
          key: 'cms',
          skipValue: 'all',
        },
      },
      ...payload,
    },
  };
};

// Save loaded freelancers
export const loadFreelancersSuccess = (freelancers) => {
  return {
    type: LOAD_FREELANCERS_SUCCESS,
    freelancers,
  };
};

// Loads cmf list
export const loadCmsList = () => {
  return {
    type: LOAD_CMS_LIST,
    payload: {
      resource: 'user-contractors/cms-list',
      onSuccess: loadCmsListSuccess,
      onErrorMessage: getIntlMessage('freelancer.load.error'),
    },
  };
};

// Save loaded cmf list
export const loadCmsListSuccess = (list) => {
  return {
    type: LOAD_CMS_LIST_SUCCESS,
    list,
  };
};

// User role update request
export const updateUserRole = (values, resolve, reject) => {
  return {
    type: UPDATE_USER_ROLE,
    promise: { resolve, reject },
    payload: {
      resource: 'user-roles',
      onSuccess: updateUserRoleSuccess,
      afterSuccess: toggleRoleForm,
      entityPrimaryKey: 'roleId',
    },
    values,
  };
};

// Successfully updated user role
export const updateUserRoleSuccess = (role) => {
  return {
    type: UPDATE_USER_ROLE_SUCCESS,
    role,
  };
};

// Send request for the role deletion
export const deleteUserRole = (roleId) => {
  return {
    type: DELETE_USER_ROLE,
    payload: {
      resource: 'user-roles',
      entityId: roleId,
      onSuccess: deleteUserRoleSuccess,
      onErrorMessage: getIntlMessage('role.delete.error'),
    },
  };
};

// Successfully deleted user role
export const deleteUserRoleSuccess = (roleId) => {
  return {
    type: DELETE_USER_ROLE_SUCCESS,
    roleId,
  };
};

// Sends request for the user role assignment update
export const updateRoleAssignment = (values, resolve, reject) => {
  return {
    type: UPDATE_ROLE_ASSIGNMENT,
    promise: { resolve, reject },
    values,
  };
};

// Successfully update user role assignment
export const updateRoleAssignmentSuccess = (response) => {
  return {
    type: UPDATE_ROLE_ASSIGNMENT_SUCCESS,
    userId: response.userId,
    role: response.role,
  };
};

// Sends request for the department update
export const updateDepartment = (values, resolve, reject) => {
  return {
    type: UPDATE_DEPARTMENT,
    promise: { resolve, reject },
    payload: {
      resource: 'user-departments',
      onSuccess: updateDepartmentSuccess,
      afterSuccess: toggleDepartmentForm,
      entityPrimaryKey: 'departmentId',
    },
    values,
  };
};

// Successfully update department
export const updateDepartmentSuccess = (department) => {
  return {
    type: UPDATE_DEPARTMENT_SUCCESS,
    department,
  };
};

// Send request for the department delete
export const deleteDepartment = (departmentId) => {
  return {
    type: DELETE_DEPARTMENT,
    payload: {
      resource: 'user-departments',
      entityId: departmentId,
      onSuccess: deleteDepartmentSuccess,
      onErrorMessage: getIntlMessage('department.delete.error'),
    },
  };
};

// Successfully delete department
export const deleteDepartmentSuccess = (departmentId) => {
  return {
    type: DELETE_DEPARTMENT_SUCCESS,
    departmentId,
  };
};

// Send request for the position update
export const updatePosition = (values, resolve, reject) => {
  return {
    type: UPDATE_POSITION,
    promise: { resolve, reject },
    payload: {
      resource: 'user-positions',
      onSuccess: updatePositionSuccess,
      afterSuccess: togglePositionForm,
      entityPrimaryKey: 'positionId',
    },
    values,
  };
};

// Successfully update position
export const updatePositionSuccess = (position) => {
  return {
    type: UPDATE_POSITION_SUCCESS,
    position,
  };
};

// Send request for the position delete
export const deletePosition = (positionId) => {
  return {
    type: DELETE_POSITION,
    payload: {
      resource: 'user-positions',
      entityId: positionId,
      onSuccess: deletePositionSuccess,
      onErrorMessage: getIntlMessage('position.delete.error'),
    },
  };
};
// Successfully delete position
export const deletePositionSuccess = (positionId) => {
  return {
    type: DELETE_POSITION_SUCCESS,
    positionId,
  };
};

// Send request for the freelancer update
export const updateFreelancer = (values, resolve, reject) => {
  return {
    type: UPDATE_FREELANCER,
    promise: { resolve, reject },
    payload: {
      resource: 'user-contractors',
      onSuccess: updateFreelancerSuccess,
      afterSuccess: toggleFreelancerForm,
      entityPrimaryKey: 'contractorId',
    },
    values,
  };
};

// Successfully update freelancer
export const updateFreelancerSuccess = (freelancer) => {
  return {
    type: UPDATE_FREELANCER_SUCCESS,
    freelancer,
  };
};

// Send request for the freelancer delete
export const deleteFreelancer = (freelancerId) => {
  return {
    type: DELETE_FREELANCER,
    payload: {
      resource: 'user-contractors',
      entityId: freelancerId,
      onSuccess: deleteFreelancerSuccess,
      onErrorMessage: getIntlMessage('position.delete.error'),
    },
  };
};

// Successfully delete freelancer
export const deleteFreelancerSuccess = (freelancerId) => {
  return {
    type: DELETE_FREELANCER_SUCCESS,
    freelancerId,
  };
};

// Send request for the user update
export const updateUser = (values, payload = {}) => {
  return {
    type: UPDATE_USER,
    payload: {
      resource: USER_PROFILES,
      extraFields: ['companyEntities'],
      onSuccess: updateUserSuccess,
      entityPrimaryKey: 'userId',
      ...payload,
    },
    values,
  };
};

// Send request for the user create
export const createUser = (payload = {}, projectId = null) => {
  let afterSuccess = toggleUserInviteForm;

  if (projectId) {
    const addToTeam = (values) =>
      createTeamMap({
        userId: values.user.userId,
        projectId: projectId,
      });

    afterSuccess = [toggleUserInviteForm, addToTeam];
  }

  return {
    type: UPDATE_USER,
    promise: payload.promise,
    payload: {
      resource: USER_PROFILES,
      onSuccess: updateUserSuccess,
      afterSuccess,
      entityPrimaryKey: 'userId',
      ...payload,
    },
    values: payload.values,
  };
};

//Update user success
export const updateUserSuccess = (user) => {
  return {
    type: UPDATE_USER_SUCCESS,
    user,
  };
};

// Send request for the username update
export const changeUsername = (values, payload = {}) => {
  return {
    type: UPDATE_USERNAME,
    payload: {
      resource: `${USERS}/change-email`,
      entityPrimaryKey: 'userId',
      ...payload,
    },
    values,
  };
};

// Send request for the applying username update
export const applyChangeUsername = (values, payload = {}) => {
  return {
    type: UPDATE_USERNAME,
    payload: {
      resource: `${USERS}/apply-change-email`,
      entityPrimaryKey: 'userId',
      onSuccess: updateUsernameSuccess,
      ...payload,
    },
    values,
  };
};

const updateUsernameSuccess = (response, action) => {
  return {
    type: UPDATE_USER_SUCCESS,
    user: {
      userId: action.values.userId,
      email: response.username,
    },
  };
};

// Send request to load companies
export const loadCompanies = (onSuccessFunction = null) => {
  return {
    type: LOAD_COMPANIES,
    payload: {
      resource: 'companies',
      onSuccess: loadCompaniesSuccess,
      onSuccessFunction,
      onErrorMessage: getIntlMessage('request.error'),
    },
  };
};

export const loadCompanyById = (companyId, payload) => {
  return {
    type: LOAD_COMPANY_BY_ID,
    payload: {
      resource: `companies/${companyId}`,
      fields: ['companyId', 'status', 'usersCount', 'filesSizesCount', 'projectsCount'],
      onSuccess: loadCompanyByIdSuccess,
      ...payload,
    },
  };
};

const loadCompanyByIdSuccess = (values) => {
  return {
    type: LOAD_COMPANY_BY_ID_SUCCESS,
    values,
  };
};

// Saves companies if request successfully finished
export const loadCompaniesSuccess = (companies) => {
  return {
    type: LOAD_COMPANIES_SUCCESS,
    companies,
  };
};

export const updateClientUser = (payload) => {
  return {
    type: UPDATE_CLIENT_USER,
    promise: payload.promise,
    payload: {
      resource: CLIENT_PROFILES,
      extraFields: ['companyEntities'],
      onSuccess: updateClientUserSuccess,
      afterSuccess: toggleUserClientForm,
      entityPrimaryKey: 'userId',
      ...payload,
    },
    values: payload.values,
  };
};
const updateClientUserSuccess = (user) => {
  return {
    type: UPDATE_CLIENT_USER_SUCCESS,
    user,
  };
};

export const createClientUser = (payload = {}, projectId) => {
  let afterSuccess = toggleClientInvitationForm;

  if (projectId) {
    const addToTeam = (values) =>
      createTeamMap({
        userId: values.user.userId,
        projectId: projectId,
        type: 'client',
      });

    afterSuccess = [toggleClientInvitationForm, addToTeam];
  }

  return {
    type: UPDATE_CLIENT_USER,
    promise: payload.promise,
    payload: {
      resource: 'clients',
      onSuccess: (res) => createClientUserSuccess(res, projectId),
      afterSuccess,
      entityPrimaryKey: 'userId',
      ...payload,
    },
    values: payload.values,
  };
};
const createClientUserSuccess = (user, projectId) => {
  return {
    type: CREATE_USER_CLIENT_SUCCESS,
    projectId,
    user,
  };
};

// Load client users
export const loadClientProfiles = () => {
  return {
    type: LOAD_CLIENT_PROFILES,
    payload: {
      resource: CLIENT_PROFILES,
      onSuccess: loadClientProfilesSuccess,
      perPage: 0,
      page: null,
    },
  };
};

const loadClientProfilesSuccess = (users) => {
  return {
    type: LOAD_CLIENT_PROFILES_SUCCESS,
    users,
  };
};

export const clearClientProfiles = () => {
  return {
    type: CLEAR_CLIENT_PROFILES,
  };
};

// Load client user by id
export const loadClientUserById = (payload = {}) => {
  return {
    type: LOAD_CLIENT_USER_BY_ID,
    payload: {
      resource: `${CLIENT_PROFILES}/${payload.userId}`,
      onSuccess: loadClientUserByIdSuccess,
      ...payload,
    },
  };
};
const loadClientUserByIdSuccess = (user) => {
  return {
    type: LOAD_CLIENT_USER_BY_ID_SUCCESS,
    user,
  };
};

// Load structure users
export const loadStructureChart = () => {
  return {
    type: LOAD_STRUCTURE_CHART,
    payload: {
      resource: `${USER_PROFILES}/structure`,
      onSuccess: loadStructureChartSuccess,
    },
  };
};

const loadStructureChartSuccess = (chart) => {
  return {
    type: LOAD_STRUCTURE_CHART_SUCCESS,
    chart,
  };
};

// Subscribes to the `online` event in websocket
export const subscribeOnline = () => {
  return {
    type: SUBSCRIBE_ONLINE,
  };
};
// Unsubscribes from the `online` event in websocket
export const unsubscribeOnline = () => {
  return {
    type: UNSUBSCRIBE_ONLINE,
  };
};

// Action handles setting of the online statuses for all users
export const setUsersOnline = (online) => {
  return {
    type: SET_USERS_ONLINE,
    online,
  };
};

// Load structure users
export const loadUserLastTask = () => {
  return {
    type: LOAD_USER_LAST_TASK,
    payload: {
      resource: `${USER_PROFILES}/last-task`,
      onSuccess: loadUserLastTaskSuccess,
    },
  };
};

const loadUserLastTaskSuccess = (stats) => {
  return {
    type: LOAD_USER_LAST_TASK_SUCCESS,
    stats,
  };
};

// Load moderate entities count
export const loadModerateCount = () => {
  return {
    type: LOAD_MODERATE_COUNT,
    payload: {
      resource: `${USER_PROFILES}/counters`,
      onSuccess: loadModerateCountSuccess,
    },
  };
};

const loadModerateCountSuccess = (values) => {
  return {
    type: LOAD_MODERATE_COUNT_SUCCESS,
    values,
  };
};

export const changeUserPassword = (values, resolve, reject) => {
  return {
    type: CHANGE_USER_PASSWORD,
    promise: { resolve, reject },
    payload: {
      resource: `${USERS}/change-password`,
      afterSuccess: toggleUserChangePasswordForm,
      onSuccessMessage: getIntlMessage('user.passwordForm.success'),
    },
    values,
  };
};

// Action for send new password
export const passwordFilling = (payload) => {
  return {
    type: PASSWORD_FILLING,
    promise: payload.promise,
    payload: {
      resource: `${USERS}/password-filling`,
      onSuccessMessage: getIntlMessage('request.success'),
      ...payload,
    },
    values: payload.values,
  };
};

export const updateUserCompany = (payload) => {
  return {
    type: UPDATE_USER_COMPANY,
    promise: payload.promise,
    payload: {
      resource: 'companies',
      onSuccess: updateUserCompanySuccess,
      entityPrimaryKey: 'companyId',
      onSuccessMessage: getIntlMessage('request.success'),
      ...payload,
    },
    values: payload.values,
  };
};
const updateUserCompanySuccess = (company) => {
  return {
    type: UPDATE_USER_COMPANY_SUCCESS,
    company,
  };
};

// Handles saving of google drive token
export const connectCompanyDrive = (data) => {
  return {
    type: CONNECT_COMPANY_DRIVE,
    payload: {
      resource: 'companies/save-drive-token',
      data,
    },
  };
};
// Handles saving of google drive connection result
export const connectCompanyDriveResult = (payload) => {
  return {
    type: CONNECT_COMPANY_DRIVE_RESULT,
    payload,
  };
};

// Handles confirmation of user's email after signing up
export const signUpConfirm = (authKey, payload) => {
  return {
    type: SIGN_UP_CONFIRM,
    payload: {
      resource: `companies/confirm`,
      onSuccess: userSignInSuccess,
      hideLoader: true,
      ...payload,
    },
    values: { authKey },
  };
};

export const disconnectTelegram = () => {
  return {
    type: DISCONNECT_TELEGRAM,
    payload: {
      resource: `${USERS}/telegram-disconnect`,
      onSuccess: disconnectTelegramSuccess,
    },
  };
};

export const disconnectTelegramSuccess = (userId) => {
  return {
    type: DISCONNECT_TELEGRAM_SUCCESS,
    userId,
  };
};

export const subscribeCredentialModerateCount = () => {
  return {
    type: SUBSCRIBE_CREDENTIAL_MODERATE_COUNT,
  };
};

export const unsubscribeCredentialModerateCount = () => {
  return {
    type: UNSUBSCRIBE_CREDENTIAL_MODERATE_COUNT,
  };
};

export const setCredentialModerateCountSocket = (payload) => {
  return {
    type: SET_CREDENTIAL_MODERATE_COUNT_SOCKET,
    payload,
  };
};

export const subscribeEventModerateCount = () => {
  return {
    type: SUBSCRIBE_EVENT_MODERATE_COUNT,
  };
};

export const unsubscribeEventModerateCount = () => {
  return {
    type: UNSUBSCRIBE_EVENT_MODERATE_COUNT,
  };
};

export const setEventModerateCountSocket = (payload) => {
  return {
    type: SET_EVENT_MODERATE_COUNT_SOCKET,
    payload,
  };
};

export const loadWorkspaces = (payload) => {
  return {
    type: LOAD_WORKSPACES,
    payload: {
      resource: WORKSPACES,
      onSuccess: loadWorkspacesSuccess,
      ...payload,
    },
  };
};
const loadWorkspacesSuccess = (values) => {
  return {
    type: LOAD_WORKSPACES_SUCCESS,
    values,
  };
};

export const selectWorkspace = (userId) => {
  return {
    type: SELECT_WORKSPACE,
    values: { userId },
  };
};

export const detectChangeWorkspace = (alias) => {
  return {
    type: DETECT_CHANGE_WORKSPACE,
    alias,
  };
};
